import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { isNewPageDesign } from '~src/services/login';
import { routes } from '~src/routingConfig';

import { FooterLink, StyledFooterLink, StyledFooter, ContactLink } from './footer.sc';

interface Props {
  pathname: string;
}

const Footer: FC<Props> = React.memo(({ pathname = null }) => {
  const [t] = useTranslation();
  return (
    <StyledFooter
      className={classNames({ 'new-footer': isNewPageDesign(pathname) })}
      data-translation="x.footer.disclaimer"
    >
      <div>
        <span>{t('x.footer.disclaimer', { year: new Date().getFullYear() })}</span>
        <StyledFooterLink target="_blank" href="http://loopline-systems.com">
          {/* tslint:disable-next-line: jsx-use-translation-function */}
          loopline-systems.com
        </StyledFooterLink>
      </div>
      {pathname !== routes.contact && (
        <ContactLink>
          <span>|</span>
          <FooterLink to={`${routes.contact}?from=footer`}>{t('x.footer.contact')}</FooterLink>
        </ContactLink>
      )}
    </StyledFooter>
  );
});

export default Footer;
